import Vue from 'vue'
import App from './App.vue'
import './assets/index.css';
// 引入vue-router
import router from './router';

Vue.config.productionTip = false

// 使用vue-router
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
